var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMisDashboardInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 1H1.2C0.537 1 0 1.537 0 2.2v8.4c0 .663.537 1.2 1.2 1.2h4.3l-.5 1.4H4.2c-.22 0-.4.18-.4.4s.18.4.4.4h5.6c.22 0 .4-.18.4-.4s-.18-.4-.4-.4H9l-.5-1.4h4.3c.663 0 1.2-.537 1.2-1.2V2.2C14 1.537 13.463 1 12.8 1zm.4 9.2c0 .22-.18.4-.4.4H1.2c-.22 0-.4-.18-.4-.4V2.2c0-.22.18-.4.4-.4h11.6c.22 0 .4.18.4.4v8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 6.5,
    width: 1.8,
    height: 2.6,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 5.1,
    width: 1.8,
    height: 4,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.5,
    width: 1.8,
    height: 5.6,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 4.8,
    width: 1.8,
    height: 4.3,
    rx: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisDashboardInactive);
export default __webpack_public_path__ + "static/media/mis_dashboard_inactive.60fd0114e663d4788c3054679ac7eea6.svg";
export { ForwardRef as ReactComponent };